export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7897.1f1fa376.jpg";